import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import Article from '@/pages/article/page';
import LocaleLayout from '@/components/feature/LocaleLayout';
import LanguageRedirect from '@/components/feature/LanguageRedirect';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LanguageRedirect />,
  },
  {
    path: '/:lang',
    element: <LocaleLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: ':slug',
        element: <Article />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;